/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { NotificationCount } from '../../models/notification-count';

export interface NotificationControllerCountMyNotifications$Params {
}

export function notificationControllerCountMyNotifications(http: HttpClient, rootUrl: string, params?: NotificationControllerCountMyNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: NotificationCount;
}>> {
  const rb = new RequestBuilder(rootUrl, notificationControllerCountMyNotifications.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: NotificationCount;
      }>;
    })
  );
}

notificationControllerCountMyNotifications.PATH = '/notification/count';
